import { render } from "./App.vue?vue&type=template&id=6f72d2b8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Coding/projects/kraiburg-website-typo3-13lts/extensions/testimonials/Resources/Private/Vue/testimonial-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__